<mat-card class="message">
    @if ( !inProcess ) {
    <mat-card-header>
        <img mat-card-lg-image src='/assets/success.png' alt='Application submitted for processing'
            class="success-image">
        <mat-card-title>{{applicationState}} <span
                class='application-id'>{{status.applicationNumber}}</span></mat-card-title>
        <mat-card-subtitle>Check your email regularly for updates on your application status. There is important
            information in the emails sent to you necessary to finalize your application.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content >
        <div>{{login?.nickname ?? login?.firstname}},</div>
        <br/>
        <p>We at {{config?.info?.institution ?? 'Mutara University'}} thank you for applying
            as {{studentType}} student for the selected term.
        </p>
        <mutara-alert label="Application Number: {{status.applicationNumber}}"
            description="Submitted: {{status.modifiedDate | date}}"></mutara-alert>
        <br/>
        <strong class="justified">It is important that you check your email:</strong>
        <p class="mutara-subtitle">{{login?.username ?? login?.email}}</p>
        <strong class="justified">for information regarding your application status.</strong>
    </mat-card-content>
    <mat-card-actions align='end'>
        @if ( timer === undefined ) {
        <button color='primary' mat-flat-button type="button" aria-label="Re-apply" matTooltip="Re-apply"
            (click)="navigateReapply()">Click here to start a new application</button>
        }
        @if ( config?.info ) {
        <a [href]="config.info?.link" [aria-label]="config.title.label">{{config.title.label}}{{ !!config.production ? '' : ` db ${config.database}`}}<img alt="{{config.title.label}" class='info-logo'
                [src]='config.info?.logo'></a>
        }
    </mat-card-actions>

    } @else {
    <img mat-card-lg-image src='/assets/success.png' alt='Loading status' class="success-image">
        <mutara-alert statusType="info" label="Application Processing...."
            description="Awaiting status information from the host environment. Please watch for an email with information about your application. Be aware the email may be found in your spam folder. "></mutara-alert>
    }
</mat-card>